(() => {
  async function runtime(url) {
    if (customElements.get('model-viewer')) return;
    window.pzModelViewerReady ||= (async () => {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        try {
          await new Promise((resolve, reject) => {
            const timer = setTimeout(() => reject(new Error('Shopify viewer timeout')), 12000);
            window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:errors=>{
              clearTimeout(timer);
              if(errors || !customElements.get('model-viewer')) reject(new Error('Shopify viewer unavailable'));
              else resolve();
            }}]);
          });
          return;
        } catch { if(customElements.get('model-viewer'))return; }
      }
      await import(url);
    })().catch(error => {
      window.pzModelViewerReady = null;
      // Shopify may register its viewer while our module is being fetched.
      if (!customElements.get('model-viewer')) throw error;
    });
    await window.pzModelViewerReady;
    await customElements.whenDefined('model-viewer');
  }
  async function sceneBlob(url) {
    const response = await fetch(url, {credentials: 'omit', cache: 'force-cache'});
    if (!response.ok) throw new Error('Scene response '+response.status);
    const scene = await response.json();
    if (scene.format !== 'petzeye-glb-base64-v1' || typeof scene.data !== 'string') throw new Error('Invalid model data');
    const encoded = scene.data;
    const padding = encoded.endsWith('==') ? 2 : encoded.endsWith('=') ? 1 : 0;
    const bytes = new Uint8Array(encoded.length*3/4-padding);
    // Decode in small chunks, avoiding a second full-size binary string on phones.
    let offset = 0;
    for (let i=0; i<encoded.length; i+=131072) {
      const block = atob(encoded.slice(i,i+131072));
      for(let j=0;j<block.length;j++)bytes[offset++]=block.charCodeAt(j);
    }
    return URL.createObjectURL(new Blob([bytes], {type:'model/gltf-binary'}));
  }
  function init(root) {
    root.querySelectorAll('[data-pz-real-scene]').forEach(viewer => {
      if (viewer.dataset.initialized) return;
      viewer.dataset.initialized='true';
      const dialog=viewer.querySelector('dialog'),open=viewer.querySelector('.pz-scene-open'),close=viewer.querySelector('.pz-scene-close'),model=viewer.querySelector('model-viewer'),status=viewer.querySelector('[data-model-status]'),retry=viewer.querySelector('[data-real-action="retry"]');
      if (!dialog.showModal) {open.hidden=true;return;}
      let pending=null, blobUrl=null, loaded=false;
      const mobile=()=>window.matchMedia('(max-width: 749px)').matches;
      const orbit=()=>viewer.dataset.sceneKey==='pz-scene-911.js'?'75deg 80deg 135%':viewer.dataset.sceneKey==='pz-scene-pze100-l.js'?'20deg 70deg 95%':['915','905','935','913-e','901'].some(key=>viewer.dataset.sceneKey==='pz-scene-'+key+'.js')?'20deg 70deg 90%':'65deg 78deg 135%';
      const failure=error=>{pending=null;loaded=false;status.hidden=false;status.textContent='The 3D view could not load. Please retry.';if(retry)retry.hidden=false;console.warn('petZeye 3D view:',error);};
      async function load(force=false) {
        if(pending)return pending;
        if(loaded&&!force){model.focus();return;}
        status.hidden=false;status.textContent='Loading 3D scene…';if(retry)retry.hidden=true;
        pending=(async()=>{
          await runtime(viewer.dataset.runtime);
          const payload=mobile()&&viewer.dataset.mobilePayload?viewer.dataset.mobilePayload:viewer.dataset.payload;
          if(payload){
            const next=await sceneBlob(payload);
            const previous=blobUrl;blobUrl=next;model.src=next;
            if(previous)URL.revokeObjectURL(previous);
          }else model.src=model.dataset.sceneSrc;
          if(dialog.open)model.focus();
        })().catch(failure).finally(()=>{pending=null;});
        return pending;
      }
      open.addEventListener('click',()=>{dialog.showModal();load();});
      if(retry)retry.addEventListener('click',()=>load(true));
      model.addEventListener('load',()=>{loaded=true;status.hidden=true;if(retry)retry.hidden=true;});
      model.addEventListener('error',event=>failure(event.detail||'Model rendering error'));
      close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',()=>{model.removeAttribute('auto-rotate');viewer.querySelector('[data-real-action="rotate"]').setAttribute('aria-pressed','false');open.focus();});
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
      viewer.querySelector('[data-real-action="reset"]').addEventListener('click',()=>{model.cameraOrbit=orbit();model.cameraTarget='auto auto auto';model.fieldOfView='35deg';});
      viewer.querySelector('[data-real-action="rotate"]').addEventListener('click',event=>{const on=!model.hasAttribute('auto-rotate');model.toggleAttribute('auto-rotate',on);event.currentTarget.setAttribute('aria-pressed',String(on));});
    });
  }
  init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
})();
